export const isAny =
  <T>(d: Array<(item: T) => boolean>) =>
  (item: T) =>
    d.some((fn) => fn(item));
